import { Theme } from '@material-ui/core';
import { createStyles } from '@material-ui/styles';

export default ({ breakpoints }: Theme, overrideClasses: any) => () =>
  createStyles({
    root: {
      overflow: 'auto',
      height: '100vh',

      '& .grecaptcha-badge': {
        visibility: 'visible',
        marginBottom: '100px !important',
      },
    },
    appBar: {
      height: 80,
      borderBottom: `1px solid #EBEBED`,
    },
    logoWrapper: {
      display: 'flex',
      alignContent: 'center',
      borderRight: `1px solid #EBEBED`,
      width: 250,
      height: '100%',
    },
    hrefLogoWrapper: {
      display: 'flex',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    logo: {
      marginTop: 18,
      marginLeft: 21,
      width: 150,
      [breakpoints.up('lg')]: {
        marginTop: 1,
        marginLeft: 40,
        paddingRight: 40,
      },
    },
    imageWrapper: {
      padding: '0 31px',
      textAlign: 'justify',
    },
    loginWrapper: {
      padding: '18px 31px',
      height: '100%',
      [breakpoints.up('lg')]: {
        width: 416,
        height: 'calc(100% - 60px)',
        padding: '18px 0px',
      },
    },
    image: {
      height: 245,
      [breakpoints.up('lg')]: {
        height: 500,
      },
      [breakpoints.up('xl')]: {
        height: 600,
        width: 644,
      },
    },
    copyrightWrapper: {
      marginTop: '46px',
      [breakpoints.up('lg')]: {
        marginTop: 0,
        padding: '0 10px 0 30px',
        backgroundColor: '#F6F6F6',
        height: 60,
      },
    },
    welcomeMessage: {
      marginBottom: 30,
    },
    ...overrideClasses,
  });
